import * as React from 'react'
import './styles.scss'

interface Props {
  text?: string
}

export const LoadingProgress = ({ text }: Props) => {
  return (
    <div className="modal-main-backdrop">
      <div className="loading-main-content">
        <div className="loading-main">
          <div className="loading-spinner">
            <div className="spinners">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <span>{text || 'Carregando informações...'}</span>
        </div>
      </div>
    </div>
  )
}
